import * as React from 'react';

import { Actions, ActionType } from './actions';
import { defaultState, store } from './store';
import { PaymentContextState } from './types';

const { Provider } = store;

function reducer(state = defaultState, action: Actions): PaymentContextState {
    switch (action.type) {
        case ActionType.SetHasInvalidCode:
            return { ...state, hasInvalidCode: action.hasInvalidCode };
        case ActionType.SetPaymentRequest:
            return { ...state, paymentRequest: action.paymentRequest };
        case ActionType.SetBillingAddressDetails:
            return {
                ...state,
                billingAddressDetails: action.billingAddressDetails
            };
        case ActionType.SetHasBillingAddress:
            return { ...state, isBillingAddressSet: action.isBillingAddressSet };
        case ActionType.SetHasBillingAddressError:
            return { ...state, hasBillingAddressError: action.hasBillingAddressError };
        case ActionType.SetTransactionUrl:
            return { ...state, transactionUrl: action.transactionUrl };
        default:
            return state;
    }
}

export function PaymentContextProvider(props: React.PropsWithChildren) {
    const [state, dispatch] = React.useReducer(reducer, { ...defaultState });

    return <Provider value={{ state, dispatch }}>{props.children}</Provider>;
};